export function enumToKeys<T extends object>(enumerable: T): Array<keyof T> {
  return Object.keys(enumerable) as any
}
